<template>
  <div class="account-page">
    <!-- 左侧侧边栏 -->
    <div class="sidebar">
      <el-input
        v-model="searchText"
        placeholder="搜索机构"
        class="sidebar-search"
        clearable
      >
        <i slot="prefix" class="el-icon-search search-icon"></i>
      </el-input>
      <div class="org-list">
        <div
          v-for="(org, idx) in filteredOrgs"
          :key="org.customer"
          :class="['org-item', { active: idx === selectedOrgIndex }]"
          @click="selectOrg(idx)"
        >
          <span class="org-name">{{ org.customer }}</span>
          <span class="org-count">人数：{{ org.total }}</span>
          <el-button
            class="add-btn"
            type="primary"
            size="mini"
            @click.stop="openAddAccountModal(org)"
          >添加账号</el-button>
        </div>
      </div>
    </div>
    <!-- 右侧账号表格区 -->
    <div class="main-content">
      <el-table :data="currentAccounts" style="width: 100%;" border stripe :max-height="650">
        <el-table-column prop="id" label="账号ID" width="100" />
        <el-table-column prop="userName" label="教师名称" />
        <el-table-column prop="accountNumber" label="邮箱" />
        <el-table-column prop="phone" label="电话" />
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="confirmDelete(scope.row)" type="danger" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 添加账号模态框 -->
    <el-dialog :visible.sync="isModalVisible" title="添加账号">
      <el-form :model="newAccount" label-width="80px">
        <el-form-item label="账号" prop="userName">
          <el-input v-model="newAccount.userName" placeholder="请输入账号号" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="newAccount.password" placeholder="请输入密码" show-password />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="newAccount.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="机构名">
          <el-input v-model="newAccount.agentMechanism" :disabled="true" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isModalVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAccount">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      orgList: [], // 机构列表
      selectedOrgIndex: 0, // 当前选中机构下标
      isModalVisible: false, // 控制模态框显示
      newAccount: { 
        userName: '', 
        password: '', 
        phone: '', 
        agentMechanism: '' 
      },
      currentRow: null, // 当前操作的机构对象
      searchText: '',
    };
  },
  computed: {
    filteredOrgs() {
      if (!this.searchText) return this.orgList;
      return this.orgList.filter(org => org.customer.includes(this.searchText));
    },
    currentAccounts() {
      if (!this.filteredOrgs.length) return [];
      return this.filteredOrgs[this.selectedOrgIndex]?.details || [];
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      const agentUserInfo = localStorage.getItem('agentUserInfo').replace(/^"|"$/g, '');
      axios
        .get(`/api/teachUsers/selectAllByInstitutionName?accountNum=${agentUserInfo}`)
        .then(response => {
          if (response.data.success) {
            const data = response.data.data;
            this.orgList = data.map(institution => ({
              customer: institution.institutionName,
              total: institution.teacherAccountCount,
              details: institution.teachUsersList.map(user => ({
                id: user.id,
                userName: user.userName,
                accountNumber: user.accountNumber,
                phone: user.phone,
              })),
            }));
          } else {
            this.$message.error('获取数据失败');
          }
        })
        .catch(() => {
          this.$message.error('请求数据失败');
        });
    },
    selectOrg(idx) {
      this.selectedOrgIndex = idx;
    },
    openAddAccountModal(org) {
      this.currentRow = org;
      this.newAccount = {
        userName: '', 
        password: '', 
        phone: '', 
        agentMechanism: org.customer 
      };
      this.isModalVisible = true;
    },
    addAccount() {
      // 校验必要字段是否存在
      if (this.newAccount.userName && this.newAccount.password && this.newAccount.phone) {
        // 组织接口需要的数据
        const accountNum = localStorage.getItem('agentUserInfo').replace(/^"|"$/g, '');
        const accountData = {
          accountNumber: this.newAccount.userName,  // 账号号
          password: this.newAccount.password, // 密码
          userName: this.newAccount.userName, // 用户名
          phone: this.newAccount.phone, // 手机号
          institutionName: this.newAccount.agentMechanism, // 代理机制
          accountNum: accountNum
        };

        // 调用接口添加账号
        axios.post('/api//teachUsers/insertAccountNum', accountData)
          .then(response => {
            if (response.data.success) {
              this.$message.success("账号添加成功！");
              this.isModalVisible = false; // 关闭模态框
              this.fetchData(); // 自动刷新账号列表
            } else {
              this.$message.error("接口请求失败，请稍后再试！");
            }
          })
          .catch(error => {
            console.error("接口请求错误", error);
            this.$message.error("网络错误，请稍后再试！");
          });
      } else {
        this.$message.error("请填写完整信息！");
      }
    },
    confirmDelete(row) {
      this.$confirm('确认删除该账号吗?', '删除账号', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const deleteId = row.id; // 获取当前行的 id

        // 调用删除接口
        axios
          .delete('/api/teachUsers/deleteById', {
            params: { id: deleteId } // 传递 id 参数
          })
          .then(response => {
            // 检查接口返回的 success 字段
            if (response.data.success) {
              this.$message.success('账号已删除！');
              // 刷新数据，或者重新请求数据
              this.fetchData(); // 重新获取数据以更新表格
            } else {
              this.$message.error('删除失败，请稍后重试！');
            }
          })
          .catch(error => {
            // 请求失败的错误处理
            console.error("请求失败：", error); // 打印详细错误信息
            this.$message.error('请求失败，请稍后重试！');
          });
      }).catch(() => {
        this.$message.info('删除已取消');
      });
    },
  },
};
</script>

<style scoped>
.account-page {
  display: flex;
  height: 100vh;
  background: #f7f9fb;
}
.sidebar {
  width: 270px;
  background: #E9F6FF;
  padding: 18px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  margin: 12px 0 12px 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.03);
}
.sidebar-search {
  width: 90%;
  margin-bottom: 18px;
  border-radius: 8px !important;
  overflow: hidden;
}
.org-list {
  width: 100%;
}
.org-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 18px;
  margin-bottom: 5px;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.18s;
}
.org-item.active {
  background: #eaf3fd;
}
.org-name {
  font-weight: 500;
  font-size: 16px;
  color: #222;
  flex: 1;
}
.org-count {
  font-size: 13px;
  color: #888;
  margin-left: 6px;
  margin-right: 15px;
}
.add-btn {
  margin-left: 0;
  background: #2EA2FA;
  border: none;
  color: #fff;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
  transition: background 0.15s;
}
.add-btn:hover {
  background: #2EA2FA;
}
.main-content {
  flex: 1;
  margin: 12px 12px 12px 0;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  padding: 24px 28px 18px 28px;
  overflow: auto;
}
/deep/ .el-table {
  border-radius: 14px;
  overflow: hidden;
}
/deep/ .el-table__header-wrapper th {
  background: #E2F3FF !important;
  color: #333;
  font-weight: 500;
  border-bottom: none;
  text-align: center;
}
/deep/ .el-table__header-wrapper tr {
  border-radius: 14px;
  overflow: hidden;
  text-align: center;
}
.search-icon {
  color: #b2b2b2;
  font-size: 18px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
/deep/ .el-input__inner {
  border-radius: 8px !important;
}
/deep/ .el-input__prefix {
  display: flex;
  align-items: center;
  left: 8px !important;
  height: 100%;
}
</style>
